import React, { useEffect, useState } from "react";
import styles from "./AboutUs.module.css";
import { TextComponent } from "../../../components";
import aboutIcon from "../../../assets/aboutus-icon.png";
import { useDispatch, useSelector } from "react-redux";
import PagesMiddleware from "../../../Store/Middlewares/PagesMiddleware";
import { Skeleton } from "antd";
const AboutUs = () => {
  const dispatch = useDispatch();
  const PagesData = useSelector(
    (state) => state?.PagesReducer.PagesInformation
  );
  const [loader, setloader] = useState(true);
  useEffect(() => {
    if (!PagesData) {
      getData();
    } else {
      setloader(false);
    }
  }, []);
  const getData = () => {
    dispatch(PagesMiddleware.getPagesInformation())
      .then((res) => {
        setloader(false);
      })
      .catch((err) => {
        setloader(false);
      });
  };
  return (
    <div>
      <div className={styles.aboutUsContainer}>
        <div className={styles.containerText}>
            {loader ? 
             <Skeleton active />
        : 
          <TextComponent textClass={styles.tcText}>
            <span
              className={styles.contentStyling}
              dangerouslySetInnerHTML={{ __html: PagesData?.about }}
            />
          </TextComponent>
          }
        </div>
        <div className={styles.containerIcon}>
          <img src={aboutIcon} alt="About Us" />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
